export default "__VITE_ASSET__BjpAA8aG__"